import { render, staticRenderFns } from "./ClamMstPopupTableInfo5.vue?vue&type=template&id=2ebfba46&"
import script from "./ClamMstPopupTableInfo5.vue?vue&type=script&lang=js&"
export * from "./ClamMstPopupTableInfo5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports